import type { Tileset, TilesetVersion, TilesetDataset } from "../types/tileset";
import { Badge, Title } from "@mantine/core";
import { memo, type FC } from "react";
import { FormattedMessage } from "react-intl";

interface VersionItemTitleProps {
  tileset: Tileset;
  dataset: TilesetDataset | null;
  version: TilesetVersion | null;
}

export const VersionItemTitle: FC<VersionItemTitleProps> = memo(({ tileset, dataset, version }) => {
  const { key: tilesetKey } = tileset;

  return (
    <>
      <Title size="20px" fw="600">
        {dataset
          ? `(${version?.id}) ${dataset.key} - ${tilesetKey}`
          : `(${version?.id}) ${tilesetKey}`}
        {version?.id === tileset.currentVersionId && (
          <Badge size="sm" variant="light">
            <FormattedMessage defaultMessage="Current" id="label.current" />
          </Badge>
        )}
      </Title>

    </>
  );
});
